<template>
  <v-container>
    <v-flex>
      <v-layout>
        <v-card class="masterCard">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            ref="table"
            :headers="headers"
            :items="users"
            :items-per-page="5"
            :rows-per-page="20"
            :search="search"
            :loading="loading"
            @click:row="viewUser"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Usuarios</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-dialog v-model="userDialog">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                      >Agregar usuario</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="10" md="8">
                            <v-text-field
                              v-model="editedItem.userName"
                              label="Nombre de usuario"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="10" md="8">
                            <v-text-field
                              v-model="editedItem.email"
                              label="correo"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-autocomplete
                              :items="roles"
                              label="Seleccione un rol"
                              v-model="editedItem.role"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="10" md="10">
                            <v-autocomplete
                              :items="organizations"
                              label="Seleccione una organización"
                              v-model="editedItem.organization"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="8" md="8">
                            <v-text-field
                              v-model="editedItem.password"
                              label="Contraseña"
                              type="password"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#015CAB" text @click="save">Guardar</v-btn>
                      <v-btn color="#E1251B" text @click="close"
                        >Cancelar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="deleteDialog" max-width="20%">
                  <v-card>
                    <v-card-text>
                      ¿Seguro que desea eliminar este usuario?
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#015CAB" text @click="deleteUser"
                        >Eliminar</v-btn
                      >
                      <v-btn color="#E1251B" text @click="closeDelete"
                        >Cancelar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.enabled="{ item }">
              <v-row style="width: 100%">
                <!-- stop prop prevent to trigget the click row event -->
                <v-spacer></v-spacer>

                <v-switch
                  v-model="item.enabled"
                  @click.stop="toggleUser(item.id, item.enabled)"
                >
                </v-switch>
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import {
  GetAllUsers,
  disableUser,
  enableUser,
  GetAllOrganizationsActive,
  registerUser,
  editUser,
  GetAllRoles,
  deleteUser,
} from "@/utils/apiRequest.js";
export default {
  data() {
    return {
      users: [],
      search: "",
      userDialog: false,
      deleteDialog: false,
      edited: false,
      loading: true,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        { text: "Usuario", value: "userName" },
        { text: "correo", value: "email" },
        { text: "Rol", value: "UserRoles[0].role.name" },
        { text: "Organización", value: "organization.name" },
        { text: "Habilitado", value: "enabled" },
        { text: "", value: "controls" },
      ],
      roles: [],
      organizations: [],
      editedItem: {
        id: "",
        userName: "",
        role: [],
        organization: "",
        enable: false,
        password: "",
        organizationID: "",
        email: "",
      },
      defaultItem: {
        id: "",
        userName: "",
        role: [],
        organization: "",
        enable: false,
        password: "",
        email: "",
      },
    };
  },
  async mounted() {
    let response = await GetAllUsers();
    if (response.data.status == "success") {
      this.users = response.data.users;
    }
    response = await GetAllOrganizationsActive();
    if (response.data.status == "success") {
      response.data.organization.forEach((organization) => {
        this.organizations.push(organization.name);
      });
    }

    response = await GetAllRoles();
    if (response.data.status == "success") {
      response.data.roles.forEach((roles) => {
        this.roles.push(roles.name);
      });
    }

    this.loading = false;
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    async toggleUser(orgID, enable) {
      if (enable) {
        await this.enableUser(orgID);
        return;
      }
      await this.disableUser(orgID);
    },
    viewUser(user) {
      try {
        const path = `/usuarios/${user.id}`;
        this.$router.push(path);
      } catch (error) {
        console.log(error);
      }
    },
    async enableUser(userID) {
      var updatedUser = await enableUser(userID);
      if (updatedUser.data.status) {
        window.location.reload();
      }
    },
    async disableUser(userID) {
      var updatedUser = await disableUser(userID);
      if (updatedUser.data.status) {
        window.location.reload();
      }
    },
    enable(status) {
      if (!status) {
        return true;
      }
      return false;
    },
    disable(status) {
      if (status) {
        return true;
      }
      return false;
    },
    close() {
      this.userDialog = false;
      this.edited = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.deleteDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    editDialog(item) {
      this.edited = true;
      this.editedItem = Object.assign({}, item);
      this.editedItem.organizationID = this.editedItem.organization.id;
      this.editedItem.organization = this.editedItem.organization.name;
      this.editedItem.role = this.editedItem.roles.split(";")[0]; // set the first role as active role
      this.userDialog = true;
    },

    deleteConfirmationDialog(item) {
      this.editedItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    async deleteUser() {
      var updatedUser = await deleteUser(this.editedItem.id);
      if (updatedUser.data.status) {
        window.location.reload();
      }
    },
    async save() {
      if (!this.edited) {
        let user = {
          username: this.editedItem.userName,
          password: this.editedItem.password,
          enabled: true,
          roles: [
            {
              roleID: this.editedItem.role,
            },
          ],
          email: this.editedItem.email,
          organizationName: this.editedItem.organization,
        };
        let updatedUser = await registerUser(user);
        if (updatedUser.data.status == "success") {
          this.users.push(updatedUser.data.user);
          this.close();
        }
      } else {
        let user = {
          id: this.editedItem.id,
          username: this.editedItem.userName,
          password: this.editedItem.password,
          enabled: this.editedItem.enabled,
          roles: [
            {
              roleID: this.editedItem.role,
            },
          ],
          email: this.editedItem.email,
          organizationName: this.editedItem.organizationID,
        };
        let updatedUser = await editUser(this.editedItem.id, user);
        if (updatedUser.data.status == "success") {
          this.edited = false;
          this.users.push(updatedUser.data.user);
        }
      }
    },
  },
};
</script>
<style scoped>
.flex {
  align-items: center;
  align-content: center;
  align-self: center;
}
.masterCard {
  align-self: center;
  margin: 0 auto;
}
</style>